export default {
  data: () => ({
    formValidation: true,

    rules: {
      requerid: (v) => !!v || "O Campo é obrigatório!",
      requeridAllowZero: (v) =>
        (v !== null && v !== undefined && v !== "") ||
        "O Campo é obrigatório!",
      email: (v) => /.+@.+/.test(v) || "O e-mail não é valido!",
      minLengthMultipleSelect: (v) => v.length > 1 || "O Campo é obrigatório!",
      minThreeChacters: (v) => v.length >= 3 || "Mínimo de 3 caracteres",
      minFiveChacters: (v) => v.length >= 5 || "Mínimo de 5 caracteres",
      minTenChacters: (v) => v.length >= 10 || "Mínimo de 10 caracteres",
      minElevenChacters: (v) => v.length >= 11 || "Mínimo de 11 caracteres",
      maxOneThousand: (v) => v.length <= 1000 || "Máximo de 1000 caracteres",
      maxOneThousandTwoHundred: (v) =>
        v.length <= 1200 || "Máximo de 1200 caracteres",
      maxTwoThousandTwoHundred: (v) =>
        v.length <= 2000 || "Máximo de 2000 caracteres",
      maxThreeThousandChacters: (v) =>
        v.length <= 3000 || "Máximo de 3000 caracteres",
    },
  }),
};
